import { useCallback, useMemo, PropsWithChildren } from 'react';

import { Button } from '@material-ui/core';

import { DialogWithActions, DialogWithActionsProps } from '..';

export type OmittedConfirmDialogProps = Omit<DialogWithActionsProps, 'setOpen' | 'open'>;

export interface ConfirmDialogProps extends PropsWithChildren<{}>
{
  dialogProps: OmittedConfirmDialogProps;
  confirmButtonText?: string;
  undoButtonText?: string;
  onConfirm: () => void;
  onUndo: () => void;
  open: boolean;
  setOpen: (v: boolean) => void;
  actionsDisabled?: boolean;
}

export function ConfirmDialog(props: ConfirmDialogProps) {
  const { 
    confirmButtonText = 'Ok', undoButtonText = 'Annulla', onConfirm, onUndo, open, setOpen, 
    children, dialogProps, actionsDisabled
  } = props;

  const confirm = useCallback(() => {
    setOpen(false);
    onConfirm();
  }, [setOpen, onConfirm]);

  const undo = useCallback(() => {
    setOpen(false);
    onUndo();
  }, [setOpen, onUndo]);

  const actions = useMemo(() => {
    return [
      <Button
        disabled={actionsDisabled}
        variant='outlined'
        color='default'
        onClick={undo}
      >
        {undoButtonText}
      </Button>,
      <Button
        disabled={actionsDisabled}
        variant='outlined'
        color='secondary'
        onClick={confirm}
      >
        {confirmButtonText}
      </Button>
    ];
  }, [confirmButtonText, undoButtonText, confirm, undo, actionsDisabled]);

  return (
    <DialogWithActions
      {...dialogProps}
      actions={actions}
      open={open}
      setOpen={setOpen}
    >
      {children}
    </DialogWithActions>
  );
}